import React, { useEffect } from 'react';
import { useLazyGetDashboardStatsQuery } from '../../../../services/Api';
import StatsCard from '../../../../components/statsCard';
import Result from './Result';
import WaveImg from '../../../../assets/wave.svg';
import ListImg from '../../../../assets/list.png';
import MapImg from '../../../../assets/destination.png';
import ItinImg from '../../../../assets/itinerary.png';
import LoaderSpiner from '../../../../components/loaderSpiner';

const Dashboard = () => {
    const [trigger, { data, isLoading, error }] = useLazyGetDashboardStatsQuery();

    useEffect(() => {
        trigger();
    }, []);

    const totalTravelerProfiles = data?.totalTravelerProfiles || 0;
    const totalPackingLists = data?.totalPackingLists || 0;
    const totalDestinations = data?.totalDestinations || 0;

    const statsCard = [
        {
            title: "Total Traveller Profiles",
            value: totalTravelerProfiles,
            bg: "bgprimary",
            icon: WaveImg,
        },
        {
            title: "Total Packing Lists",
            value: totalPackingLists,
            bg: "white",
            icon: ListImg,
        },
        {
            title: "Itineraries",
            value: 0, // No itinerary data in the API response, set to 0
            bg: "white",
            icon: ItinImg,
        },
        {
            title: "Destinations",
            // value: totalDestinations,
            value: 0,
            bg: "white",
            icon: MapImg,
        },
    ];

    if (isLoading) {
        return <p><LoaderSpiner /></p>;
    }

    if (error) {
        return <p className="text-errorcolor">Error loading data. Please try again later.</p>;
    }

    return (
        <div className="sm:px-8 px-6 pb-5">
            <div className="grid my-4 md:grid-cols-4 grid-cols-1 gap-3 whitespace-nowrap">
                {statsCard.map((item, index) => (
                    <StatsCard
                        key={index}
                        title={item.title}
                        value={String(item.value)}
                        bg={item.bg}
                        icon={item.icon}
                    />
                ))}
            </div>
            <Result />
        </div>
    );
};

export default Dashboard;
